/**
 * Design System — single source of truth for reusable class strings.
 * Import and use these instead of writing raw Tailwind in pages/components.
 * Changes here propagate everywhere automatically.
 */

// ─── Layout ───────────────────────────────────────────────────────────────────

/** Standard content-width container with horizontal padding */
export const container = 'max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8';

/** Narrower container for text-heavy sections (articles, detail pages) */
export const containerNarrow = 'max-w-5xl mx-auto px-4 sm:px-6 lg:px-8';

/** Narrower container for text-heavy sections (articles, detail pages) */
export const containerMedium = 'max-w-6xl mx-auto px-4 sm:px-6 lg:px-8';

// ─── Section spacing ──────────────────────────────────────────────────────────

/** Standard vertical section padding */
export const sectionPadding = 'py-12 md:py-16';

// ─── Section backgrounds ──────────────────────────────────────────────────────

export const sectionBgWhite   = 'bg-white';
export const sectionBgLight   = 'bg-gray-50';
export const sectionBgAmber   = 'bg-gradient-to-br from-amber-50 to-orange-50';

// ─── Typography ───────────────────────────────────────────────────────────────

/** Section heading (h2) */
export const headingLg   = 'text-2xl md:text-3xl font-bold';

/** Standard body text color */
export const textBody    = 'text-gray-600';

/** Section label/eyebrow above a heading */
export const eyebrow     = 'text-xs font-semibold text-emerald-600 uppercase tracking-widest';

// ─── Buttons ──────────────────────────────────────────────────────────────────

/**
 * Centralized Button System
 * Use <Button variant="primary|secondary|ghost" size="xs|sm|default|lg|xl|icon"> from @/components/ui/button
 *
 * Primary: Green buttons for main actions
 * Secondary: Grey buttons for secondary actions
 * Ghost: Outlined grey buttons for tertiary actions
 * Dark variants available for dark backgrounds
 */

// ─── Carousel ─────────────────────────────────────────────────────────────────

/** Wraps a Carousel to fix horizontal overflow while keeping hover scale visible */
export const carouselWrapper = 'overflow-y-visible py-3';